import { useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import i18next from 'i18next';
import Devices from 'types/Devices';
import Result from 'components/Result';
import { DesktopButton, MobileButton, ResetButton } from "components/Buttons";
import { TitleInput, DescriptionInput, UrlInput } from 'components/Inputs';
import HiddenResult from "components/HiddenResult";
import 'assets/css/components/MetatagChecker.scss';

const MetatagChecker = (): JSX.Element => {
  const [activeDevice, setActiveDevice] = useState<Devices>(Devices.Desktop)
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [url, setUrl] = useState("");

  const [currentLanguage, setCurrentLanguage] = useState("");
  const { language } = useParams()
  const navigate = useNavigate();

  useEffect(() => {
    i18next.changeLanguage(language, () => {
      navigate(`/${i18next.resolvedLanguage}`, { replace: true })
      setCurrentLanguage(i18next.resolvedLanguage);
    });
  }, [language]);

  const reset = () => {
    setTitle("");
    setDescription("");
    setUrl("");
  }

  return (
    <article className='box'>

      <header className='box-header'>

        <div className='box-header__main-actions'>
          <div className='box-header__main-action'>
            <DesktopButton
              onClick={ setActiveDevice }
              activeDevice={ activeDevice }
            />
          </div>
          <div className='box-header__main-action'>
            <MobileButton
              onClick={ setActiveDevice }
              activeDevice={ activeDevice }
            />
          </div>
        </div>

        <div className='box-header__extra-actions'>
          <div className='box-header__extra-action'>
            <ResetButton onClick={ reset } />
          </div>
        </div>

      </header>

      <div className='box-content'>

        <div className='box-content__preview'>
          <Result
            type={ activeDevice }
            url={ url }
            title={ title }
            description={ description }
          />
        </div>

        <form className='box-form'>
          <div className='box-form__item'>
            <TitleInput
              value={ title }
              onChange={ setTitle }
              type={ activeDevice }
            />
          </div>
          <div className='box-form__item'>
            <DescriptionInput
              value={ description }
              onChange={ setDescription }
              type={ activeDevice }
            />
          </div>
          <div className='box-form__item'>
            <UrlInput
              value={ url }
              onChange={ setUrl }
              type={ activeDevice }
            />
          </div>
        </form>

        <HiddenResult
          type={ activeDevice }
          url={ url }
          title={ title }
          description={ description }
        />

      </div>

    </article>
  )
};

export default MetatagChecker;
